import React, { useContext, useEffect, useRef, useState } from 'react';

import { useTranslation } from "react-i18next";
import { DataGrid } from '@mui/x-data-grid';

import {API, getCountries} from '../services/api';
import jwtInterceoptor from '../components/shared/jwtInterceptor';

import { date_formats } from '../services/data';

import moment from 'moment';

import Swal from 'sweetalert2';
import ReactSwitch from 'react-switch';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import OrgContext from '../organisation/OrgContext';
import GoBack from "../components/goBack";
import { frFR, enUS } from '@mui/x-data-grid';
import {LinearProgress} from "@mui/material";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    },
}));
function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            }}
        >
            x
        </IconButton>
        ) : null}
    </DialogTitle>
    );
}  

function CurrenciesList(props) {

    const [t, i18n] = useTranslation();

    const { organisation, changeOrg } = useContext(OrgContext);

    const [organisations, setOrganisations] = useState([]);
    const [currencies, setCurrencies] = useState([]);

    const [currencies_data, setCurrenciesData] = useState([]);

    const [open, setOpen] = React.useState(false);

    const [defaultCurrency, setDefaultCurrency] = useState(organisation?.currency_id);
    const [loadingData, setLoadingData] = useState(false);

    const org = useRef("");
    const select_currency = useRef("");
    const symbol_currency = useRef("");
    const name_currency = useRef("");

    useEffect(()=>{

        // const fetchOrganisations = async () => {
        //     const response = await jwtInterceoptor.get("/data/organisations");

        //     if(response.status === 200){
        //         setOrganisations(response.data.data);
        //     }
        // };

        const fetchCurrenciesData = async () => {
            const response = await jwtInterceoptor.get("/data/currencies");

            if(response.status === 200){
                setCurrenciesData(response.data.data);
            }
        };

        const fetchCurrencies = async () => {
            setLoadingData(true);
            const response = await jwtInterceoptor.get(`/data/organisation_currencies/${organisation.id}`);
    
            if(response.status === 200){
                setCurrencies(response.data.data);
            }
            setLoadingData(false);
        }

        if(organisation.id){
            fetchCurrencies();
        }

        fetchCurrenciesData();

        // fetchOrganisations();

        // console.log("organisation", organisation);
        
    }, []);

    

    const deleteItem = async (cur) =>{
        Swal.fire({
            title: t('Are you sure?'),
            text: t("You won't be able to revert this!"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('Yes, delete it!'),
            cancelButtonText: t("Cancel")
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await jwtInterceoptor.delete(`/data/organisation_currencies/${cur.c_org_id}`);

                if(response.status === 200){
                    if(response.data.status == true){
                        let currens = currencies.filter(el => el.c_org_id != cur.c_org_id);

                        setCurrencies(currens);


                        Swal.fire(
                            t('Deleted!'),
                            t('Your record has been deleted.'),
                            'success'
                        )

                        return;
                    }
                    
                }

                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
                
            }
        })
    }

    const formatNumber = (number) => {
        let result = number.toString().padStart(8, '0')
        return result;
    }

    const fetchCurrencies = async () => {
        const response = await jwtInterceoptor.get(`/data/organisation_currencies/${organisation.id}`);

        if(response.status === 200){
            setCurrencies(response.data.data);
        }
    }

    const loadCurrencies = () => {
        if(org.current.value !== "Organisation"){
            setCurrencies([]);
            fetchCurrencies(org.current.value);
        }
    }

    const selectedCurrency = () => {
        if(select_currency.current.value.trim().length > 0){
            const index = currencies_data.findIndex((e) => e.id == select_currency.current.value);
            const currency = currencies_data[index];
            symbol_currency.current.value = currency.symbol;
            name_currency.current.value = currency.name;
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        symbol_currency.current.value = "";
        name_currency.current.value = "";
        select_currency.current.value = "";
    };
  

    const saveCurrency = async () => {
        if(
            select_currency.current.value.trim().length > 0 
            && symbol_currency.current.value.trim().length > 0
            && name_currency.current.value.trim().length > 0
            && organisation.id
        ){
            try {

                let formData = new FormData();

                formData.append("currency_id", select_currency.current.value);
                formData.append("organisation_id", organisation.id);
        
                const response = await jwtInterceoptor.post(
                    "/data/organisation_currencies",
                    formData, 
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if(response.status == 200){
                    if(response.data.status == true){
                        
                        // const index = currencies_data.findIndex((e) => e.id == select_currency.current.value);
                        // const currency = currencies_data[index];

                        // let data = currencies;
                        // data.push(currency);
                        
                        // setCurrencies(data);

                        setCurrencies([]);

                        fetchCurrencies()


                        handleClose();
                        Swal.fire({
                            icon: 'success',
                            text: t(response.data.message),
                        });
                        
                    }else{
                        Swal.fire({
                            icon: 'warning',
                            title: '',
                            text: t(response.data.message),
                        });
                    }
                }else{
                    Swal.fire({
                        icon: 'warning',
                        title: '',
                        text: t('Something went wrong!, try again'),
                    });
                }

                
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
            }
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Fill all fields'),
            });
        }
    }

    const columns = [
        { field: 'name', headerName: t("Nom"), flex: 1, },
        { field: 'symbol', headerName: t("Symbole"), flex: 1, },
        {
            field: 'default',
            headerName: t("Par défaut"),
            width: 180,
            sortable: false,
            disableClickEventBubbling: true,
            
            renderCell: (params) => {

                const handleChange = val => {
                    if(val && val == true){
                        updateCurreny(params.row);
                    }
                }
                
                return (
                    <div className="btn-list">
                        <ReactSwitch
                            checked={params.row?.id == defaultCurrency ? true : false}
                            onChange={handleChange}

                        />
                    </div>
                );
            },
        },
        {
            field: 'action',
            headerName: t("ACTIONS"),
            width: 180,
            sortable: false,
            disableClickEventBubbling: true,
            
            renderCell: (params) => {
                const onDelete = (e) => {
                  const currentRow = params.row;
                  return deleteItem(currentRow);
                };
                
                return (
                    <div className="btn-list">
                        <button onClick={onDelete} id="bDel" type="button" className="btn  btn-sm btn-danger">
                            <span className="fe fe-trash-2"> </span>
                        </button>
                    </div>
                );
            },
          }
       
    ];

    const updateCurreny = async (curr) => {
        const indexCurrency = currencies_data.findIndex((item) => item.code == curr.code);
        if(indexCurrency > -1){
            let cury = currencies_data[indexCurrency];
            let formData = new FormData();

                formData.append("currency_id", cury.id);
                formData.append("organisation_id", organisation?.id);
        
                const response = await jwtInterceoptor.post(
                    "/data/set/default/currency",
                    formData, 
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if(response.status == 200){
                    if(response.data.status == true){
                        setDefaultCurrency(curr.id);
                        // update local org
                        let org = organisation;
                        org["currency_id"] = cury.id;
                        org["currency"] = cury;
                        changeOrg(org);
                    }
                }
            
        }
        
    }

    return (
        <>
            <GoBack route='/devises' />
            <div className="row" style={{ zIndex: 1}}>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header container-fluid d-flex justify-content-between align-items-center">
                            <div className=" card-title m-b-0">{t("Devises")}</div>
                             {organisation && organisation.id ? (
                                <Button className='btn btn-primary' variant="outlined" onClick={handleClickOpen}>
                                    {t("Ajouter nouveau")}
                                </Button>
                                ): null
                            }
                           
                        </div>
                        <div className="card-body">
                            <br/>
                            <br/>
                            
                            
                            <div className="table-responsive">
                                <div style={{ height: 600, width: '100%' }}>
                                    <DataGrid
                                        rows={currencies}
                                        columns={columns}
                                        pagination={false}
                                        checkboxSelection
                                        localeText={
                                            i18n.language == "fr" ?
                                                frFR.components.MuiDataGrid.defaultProps.localeText :
                                                enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                        }}
                                        loading={loadingData}
                                    />
                                </div>
                                {/* <table className="table table-bordered border text-nowrap mb-0" id="new-edit">
                                    <thead>
                                        <tr>
                                            <th>{t("Nom")}</th>
                                            <th>{t("Symbole")}</th>
                                           
                                            <th name="bstable-actions">{t("Actions")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currencies.map((c) => 
                                            <tr key={c.id}>
                                                <td>{c.name}</td>
                                                <td>{c.symbol}</td>
                                                <td name="bstable-actions">
                                                    <div className="btn-list">
                                                        <button onClick={()=>{
                                                            deleteItem(c);
                                                        }} id="bDel" type="button" className="btn  btn-sm btn-danger">
                                                            <span className="fe fe-trash-2"> </span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            
                style={{ zIndex: 2}}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {t("Add new currency")}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <div className="form-group">
                        <label className="form-label">{t("Code de la devise")} <span className="text-red">*</span></label>
                    
                        <select onChange={selectedCurrency} ref={select_currency} className="form-control form-select" placeholder={t("Adresse de l'entreprise")} >
                            <option></option>
                            { currencies_data.map((c) => <option key={c.id} value={c.id}>{c.code} - {c.name}</option>)}
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="form-label">{t("Symbole de la devise")} <span className="text-red">*</span></label>
                        <input disabled ref={symbol_currency} type="text" className="form-control" placeholder={t("Symbole de la devise")} />
                    </div>
                    <div className="form-group">
                        <label className="form-label">{t("Nom de la devise")} <span className="text-red">*</span></label>
                        <input disabled ref={name_currency} type="text" className="form-control" placeholder={t("Nom de la devise")} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>
                        {t("Cancel")}
                    </Button>
                    <Button autoFocus onClick={saveCurrency}>
                        {t("Sauvegarder les modifications")}
                    </Button>
                </DialogActions>
            </BootstrapDialog>

        </>
    );
}

export default CurrenciesList;